import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import { injectFromApp } from "../../../shared-components/inject";
import { injectFromAppUpload } from "../../inject";
import type { FileUpload } from "../../FileUpload";
import { humanizeFileSize } from "../../../util/functions/humanizeFileSize";
import { ParagraphRichToolTipComponent, RichToolTipComponent } from "../../../shared-components/rich-tooltip/RichToolTipComponent";
import { ProgressBarComponent } from "../../../shared-components/progress-bar/ProgressBarComponent";
import type { PatientToUpload } from "../../PatientToUpload";

interface IFileUploadComponentProps {
    resourcesStore?: IResourcesStore;
    file: FileUpload;
    patientToUpload?: PatientToUpload;
}

@injectFromApp<IFileUploadComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@injectFromAppUpload<IFileUploadComponentProps>((stores) => ({}))

@observer
export class FileUploadComponent extends React.Component<IFileUploadComponentProps> {
    remove = (event): void => {
        const { patientToUpload, file } = this.props;
        if (!patientToUpload) return;
        patientToUpload.removeFile(file);
    };

    render() {
        const { resourcesStore, file } = this.props;
        const { checking, fileIsADicomFile, fileIsADicomDirFile, removable, uploadable, fileSizeIsOk, fileNameLengthIsOk, progress, name, size, status } = file;
        const { resources } = resourcesStore!;

        const sliceName: boolean = name.length > 40;
        const displayName = sliceName ? name.slice(0, 40) + "..." : name;

        let selectedFileClasses: string = "";
        if (checking) {
            selectedFileClasses = "checking";
        } else {
            selectedFileClasses = uploadable ? "uploadable" : "not-uploadable";
        }

        return (
            <div className={ "selected-file " + selectedFileClasses }>
                { !checking && !uploadable && (
                    <>
                        <div className={ "info" }>
                            { sliceName ? (
                                <ParagraphRichToolTipComponent toolTipPosition={ "top-left" } toolTipContent={ name }>
                                    { displayName } <span>({ humanizeFileSize(size) })</span>
                                </ParagraphRichToolTipComponent>
                            ) : (
                                <p>
                                    { displayName } <span>({ humanizeFileSize(size) })</span>
                                </p>
                            ) }
                        </div>
                        <p className={ "reason" }>
                            { !fileIsADicomFile && (
                                <>
                                    { resources.ThisIsNotADICOMFile } <br/>
                                </>
                            ) }
                            { !fileSizeIsOk && (
                                <>
                                    { resources.FileIsTooLarge } <br/>
                                </>
                            ) }
                            { !fileNameLengthIsOk && (
                                <>
                                    { resources.FilenameLengthTooLarge } <br/>
                                </>
                            ) }
                            { fileIsADicomDirFile && (
                                <>
                                    { resources.DICOMDIRFilesAreUnnecessary }
                                    <br/>
                                </>
                            ) }
                        </p>
                    </>
                ) }
                { !checking && uploadable && (
                    <ProgressBarComponent progress={ progress } status={ status } detailed={ true }>
                        { displayName } <span>({ humanizeFileSize(size) })</span>
                    </ProgressBarComponent>
                ) }
                { removable && (
                    <RichToolTipComponent toolTipResource={ "RemoveFile" } className={ "remove-file" } onClick={ this.remove }>
                        &nbsp;
                    </RichToolTipComponent>
                ) }
            </div>
        );
    }
}
